import React from 'react';
import classNames from 'classnames';
import { SecondaryButton } from '@JohnLewisPartnership/jl-design-system/elements/button/Button';
import { useRouter } from 'next/router';
import { useAnchorCardContext } from '../../../context/AnchorCardContext';
import { useProductCardSize } from '../../../hooks/useProductCardSize';
import {
  dispatchImmediateAnalyticsEvent,
  GLOBAL_INTERACTION,
} from '../../analytics/analyticsEvents';
import styles from './ProductCardToggles.module.scss';

export const ProductCardToggles = () => {
  const { isLargeCardSize, largeCardUrl, standardCardUrl } =
    useProductCardSize();

  const { setAnchorCard } = useAnchorCardContext();

  const router = useRouter();

  const handleClick = () => {
    const topOfControls = document
      .querySelector('[data-test="component-sticky-controls"]')
      .getBoundingClientRect().top;

    const productCards = document.querySelectorAll(
      '[data-test="product-card"]'
    );

    const firstCardInView = Array.from(productCards).find(
      (el) => el.getBoundingClientRect().top >= topOfControls
    );

    const firstCardPid = firstCardInView.dataset.productId;

    const toggleUrl = isLargeCardSize ? standardCardUrl : largeCardUrl;
    router.push(toggleUrl.href, toggleUrl.as, { scroll: false });

    dispatchImmediateAnalyticsEvent(GLOBAL_INTERACTION, {
      action: GLOBAL_INTERACTION,
      type: 'plp',
      subType: 'card size toggle',
      additionalInfo: { size: !isLargeCardSize ? 'large' : 'small' },
      properties: {},
      products: [{}],
    });

    if (window.scrollY) {
      setAnchorCard(firstCardPid);
    } else {
      setAnchorCard(null);
    }
  };

  return (
    <div
      data-test="product-card-toggle-form"
      className={classNames(styles.form)}
    >
      <span className={classNames(styles.formLabel)}>Image Size</span>

      <SecondaryButton
        role="switch"
        aria-checked={isLargeCardSize}
        aria-label="Larger product images"
        className={classNames(styles.toggleButton)}
        onClick={handleClick}
      >
        <ToggleOption option="small" selected={!isLargeCardSize} />
        <ToggleOption option="large" selected={isLargeCardSize} />
      </SecondaryButton>
    </div>
  );
};

export const SizeIcon = ({ type = 'small' }) => (
  <span
    className={classNames(styles.sizeIcon, {
      [styles[`icon-${type}`]]: true,
    })}
  />
);

export const ToggleOption = ({ option, selected }) => {
  const displayName = {
    small: 'Small',
    large: 'Large',
  };

  return (
    <>
      <div
        data-test={`product-card-toggle-button-${option}`}
        className={classNames(styles.toggleOption, {
          [styles[`option-${option}`]]: true,
          [styles.selected]: selected,
        })}
      >
        <SizeIcon type={option} />
        <div className={classNames(styles.toggleOptionText)}>
          {displayName[option]}
        </div>
      </div>
    </>
  );
};
